import ActionTypes from '../actionTypes';
import apiTypings from '@categoryProduct/api/optimalprint-sdk';

const setIllustrations = (illustrations: apiTypings.AppBundle.Api.Entity.Design.V1.IBirthPosterIllustration[]) => ({
  type: ActionTypes.BIRTH_POSTERS_SET_ILLUSTRATIONS,
  illustrations,
});

export default setIllustrations;
